export const sharedManagedTableDe = {
  "Customize columns": "Spalten anpassen",
  "Column": "Spalte",
  "Done": "fertig",
  "Search columns...": "Spalten suchen...",
  "Select columns to display and drag them to change the order.":
    "Wähle die angezeigten Spalten aus und ziehe sie, um die Reihenfolge zu ändern.",
} as const;

export const sharedManagedTableEn = {
  "Customize columns": "Customize columns",
  "Column": "Column",
  "Done": "Done",
  "Search columns...": "Search columns...",
  "Select columns to display and drag them to change the order.":
    "Select columns to display and drag them to change the order.",
} as const;

export const sharedManagedTableTranslations = {
  de: sharedManagedTableDe,
  en: sharedManagedTableEn,
  ru: {
    "Customize columns": "Настроить столбцы", "Column": "Столбец", "Done": "готово",
    "Search columns...": "Поиск столбцов...",
    "Select columns to display and drag them to change the order.": "Выберите отображаемые столбцы и перетащите их, чтобы изменить порядок.",
  },
  uk: {
    "Customize columns": "Налаштувати стовпці", "Column": "Стовпець", "Done": "готово",
    "Search columns...": "Пошук стовпців...",
    "Select columns to display and drag them to change the order.": "Виберіть стовпці для відображення та перетягніть їх, щоб змінити порядок.",
  },
  it: {
    "Customize columns": "Personalizza colonne", "Column": "Colonna", "Done": "fine",
    "Search columns...": "Cerca colonne...",
    "Select columns to display and drag them to change the order.": "Seleziona le colonne da visualizzare e trascinale per cambiarne l’ordine.",
  },
} as const;

export type SharedManagedTableLang = keyof typeof sharedManagedTableTranslations;
export type SharedManagedTableKey = keyof typeof sharedManagedTableDe;

export function managedTableText(lang: string, key: string): string {
  const translations: Record<string, string> = sharedManagedTableTranslations[lang.split("-")[0] as SharedManagedTableLang] ?? sharedManagedTableDe;
  return translations[key] ?? key;
}
